import React, { useState, useEffect } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import SchoolPoll from "./components/SchoolPoll";
import SchoolCampus from "./components/SchoolCampus";

import Navbar from "./components/Navbar";
import MenuBar from "./components/MenuBar";
import FloatingActions from "./components/FloatingActions";
import Footer from "./components/Footer";
import Home from "./components/Home";
import SchoolGems from "./components/SchoolGems";
import FooterSection from "./components/FooterSection";

import AdmissionForm from "./pages/AdmissionForm";
import AdmissionProcess from "./components/AdmissionProcess";
import FeeStructure from "./components/FeeStructure";
import AdmissionEnquiryForm from "./components/AdmissionEnquiryForm";
import BookMeeting from "./components/BookMeeting";
import Career from "./pages/Career";
import Contact from "./components/Contact";
import AboutUs from "./components/AboutUs";
import ManagementTeam from "./components/ManagementTeam";
import VisionMission from "./pages/VisionMission";
import Curriculum from "./pages/Curriculum";
import GlobalMontessori from "./components/GlobalMontessori";
import CBSESection from "./components/CBSESection";
import SchoolLevel from "./pages/SchoolLevel";
import PrePrimary from "./components/SchoolLevels/PrePrimary";
import PrimarySchool from "./components/SchoolLevels/PrimarySchool";
import SecondarySchool from "./components/SchoolLevels/SecondarySchool";
import HighSchool from "./components/SchoolLevels/HighSchool";
import Student from "./pages/Student";

import FacilitiesPage from "./components/student/FacilitiesPage";
import ECA from "./components/student/ECA";
import CoCurricular from "./components/student/CoCurricular";
import EventsActivities from "./components/student/EventsActivities";
import ParentEngagements from "./components/student/ParentEngagements";
import SafetySecurity from "./components/student/SafetySecurity";
import HappinessIndex from "./components/student/HappinessIndex";
import UniversityPlacements from "./components/student/UniversityPlacements";
import Faculty from "./components/student/Faculty";
import ValueAddedProgrammes from "./components/student/ValueAddedProgrammes";
import HistoryMilestone from "./components/HistoryMilestone";

import Disclosure from "./pages/Disclosure";
import ScrollToTop from "./components/ScrollToTop";
import Scholorship from "./pages/scholorship";
import RecentBlogs from "./components/resources/RecentBlogs";
import MostRead from "./components/resources/MostRead";
import TrendingNews from "./components/resources/TrendingNews";
import CampusNews from "./components/resources/CampusNews";
import Videos from "./components/resources/Videos";
import FeaturedBlogs from "./components/resources/FeaturedBlogs";

import Fund from "./pages/fund";
import AdminApplications from "./pages/AdminApplications";
import Resources from "./components/Resources";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import TermsOfService from "./pages/TermsOfService";
import UpcomingEvents from "./pages/UpcomingEvents";
import TransferCertificate from "./pages/TransferCertificate";
import PublicVsPrivate from "./pages/PublicVsPrivate";
import Photos from "./pages/Photos";
import SiteMap from "./pages/SiteMap";
import RegistrationForm from "./pages/RegistrationForm";

function App() {
  const [showPoll, setShowPoll] = useState(false);

  useEffect(() => {
    const hasVoted = sessionStorage.getItem("hasVoted");
    if (!hasVoted) {
      setTimeout(() => setShowPoll(true), 2000);
    }
  }, []);

  const closePoll = () => {
    setShowPoll(false);
    sessionStorage.setItem("hasVoted", "true");
  };
  return (
    <Router>
      {showPoll && <SchoolPoll isPopup={true} onClose={closePoll} />}
      <div className="App">
        <Navbar />
        <MenuBar />
        <FloatingActions />
        <ScrollToTop />
        <Routes>
          <Route path="/poll" element={<SchoolPoll isPopup={false} />} /> {}
          <Route path="/registration" element={<RegistrationForm />} />
          <Route path="/" element={<Home />} />
          <Route path="/school-gems" element={<SchoolGems />} />
          <Route path="/admission" element={<AdmissionForm />} />
          <Route path="/admission-process" element={<AdmissionProcess />} />
          <Route path="/feestructure" element={<FeeStructure />} />
          <Route
            path="/admissionenquiryform"
            element={<AdmissionEnquiryForm />}
          />
          <Route path="/Book-Meeting" element={<BookMeeting />} />
          <Route path="/upcoming-events" element={<UpcomingEvents />} />
          <Route
            path="/transfer-certificate"
            element={<TransferCertificate />}
          />
          <Route path="/publicvsprivate" element={<PublicVsPrivate />} />
          <Route path="/career" element={<Career />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/about" element={<AboutUs />} />
          <Route path="/history-milestone" element={<HistoryMilestone />} />
          <Route path="/School-campus" element={<SchoolCampus />} />
          <Route path="/management-team" element={<ManagementTeam />} />
          <Route path="/vision-mission" element={<VisionMission />} />
          <Route path="/curriculum" element={<Curriculum />} />
          <Route path="/primarycurricula" element={<GlobalMontessori />} />
          <Route path="/seeb" element={<CBSESection />} />
          <Route path="/school-level" element={<SchoolLevel />} />
          <Route path="/pre-primary" element={<PrePrimary />} />
          <Route path="/primary-school" element={<PrimarySchool />} />
          <Route path="/secondary-school" element={<SecondarySchool />} />
          <Route path="/high-school" element={<HighSchool />} />
          <Route path="/student-life" element={<Student />} />
          <Route path="/facilitiespage" element={<FacilitiesPage />} />
          <Route path="/eca" element={<ECA />} />
          <Route path="/co-curricular" element={<CoCurricular />} />
          <Route path="/events&activities" element={<EventsActivities />} />
          <Route path="/parent-engagement" element={<ParentEngagements />} />
          <Route path="/safety-security" element={<SafetySecurity />} />
          <Route path="/happiness-index" element={<HappinessIndex />} />
          <Route
            path="/University-Placement"
            element={<UniversityPlacements />}
          />
          <Route
            path="/ValueAddedProgrammes"
            element={<ValueAddedProgrammes />}
          />
          <Route path="/faculty" element={<Faculty />} />
          <Route path="/public-disclosure" element={<Disclosure />} />
          <Route path="/scholarship" element={<Scholorship />} />
          <Route path="/resources" element={<Resources />} />
          <Route path="/recent-blogs" element={<RecentBlogs />} />
          <Route path="/most-read" element={<MostRead />} />
          <Route path="/trending-news" element={<TrendingNews />} />
          <Route path="/campus-news" element={<CampusNews />} />
          <Route path="/videos" element={<Videos />} />
          <Route path="/photos" element={<Photos />} />
          <Route path="/featured-blogs" element={<FeaturedBlogs />} />
          <Route path="/fund-raising" element={<Fund />} />
          <Route path="/submit-data" element={<AdminApplications />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/TermsOfService" element={<TermsOfService />} />
          <Route path="/sitemap" element={<SiteMap />} />
        </Routes>
        <FooterSection />
        <Footer />
      </div>
    </Router>
  );
}

export default App;
